exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sv-screen {\n  position: relative;\n}\n.sv-screen .sv-screen-controls {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 5;\n}\n.sv-screen .sv-screen-controls button {\n  display: block;\n  background: rgba(0,0,0,0.4);\n  font-size: 1.5em;\n}\n.sv-screen .sv-screen-controls button:hover {\n  color: #ff0;\n  border-color: rgba(0,0,0,0);\n}\n.sv-screen .sv-screen-controls button.highlighted {\n  color: #ff0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sergeisidorov/Projects/streamViewer/src/app/components/screen.component/screen.component.styl
// module id = ../../../../../src/app/components/screen.component/screen.component.styl
// module chunks = main